import {
  LOGIN_RESET,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  SET_UNAUTHORIZED_MESSAGE_VISIBLE
} from '../actions/login';
import {
  FORGOT_PASSWORD_RESET,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE
} from '../actions/forgotPassword';
import {
  RESET_PASSWORD_RESET,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_MATCH_FAILURE,
  RESET_PASSWORD_NOT_FOUND_FAILURE
} from '../actions/resetPassword';
import { SET_PROFILE } from '../actions/profile';
import { LOGOUT_SUCCESS } from '../actions/logout';
import {
  SIGN_UP_OPEN_MODAL,
  SIGN_UP_CLOSE_MODAL,
  LOGIN_OPEN_MODAL,
  LOGIN_CLOSE_MODAL,
  REQUEST_SENT_OPEN_MODAL,
  REQUEST_SENT_CLOSE_MODAL,
  FORGOT_PASSWORD_OPEN_MODAL,
  FORGOT_PASSWORD_CLOSE_MODAL,
  PROFILE_EDITOR_OPEN_MODAL,
  PROFILE_EDITOR_CLOSE_MODAL,
  PROFILE_SELECTOR_OPEN_MODAL,
  PROFILE_SELECTOR_CLOSE_MODAL,
  PROFILE_ENTER_MANAGE_MODE,
  PROFILE_LEAVE_MANAGE_MODE,
  LOCK_DIARY
} from '../actions/auth';

import api from '../api';

const UNLOCK_REQUEST = api.events.profilesUnlock.actionFetch;
const UNLOCK_SUCCESS = api.events.profilesUnlock.actionSuccess;
const UNLOCK_FAILURE = api.events.profilesUnlock.actionFail;

const PROFILE_PATCH_REQUEST = api.events.profilesPatch.actionFetch;
const PROFILE_PATCH_SUCCESS = api.events.profilesPatch.actionSuccess;
const PROFILE_PATCH_FAILURE = api.events.profilesPatch.actionFail;

const PROFILE_POST_REQUEST = api.events.profilesPost.actionFetch;
const PROFILE_POST_SUCCESS = api.events.profilesPost.actionSuccess;
const PROFILE_POST_FAILURE = api.events.profilesPost.actionFail;

const INVITES_REDEEM_SUCCESS = api.events.invitesRedeem.actionSuccess;

const defaultState = {
  editingProfile: null,
  hasToken: false,
  hasProfile: false,
  isFetching: false,
  isForgotPasswordModalOpen: false,
  isRequestSentModalOpen: false,
  isForgotPasswordSuccessMessageVisible: false,
  isIncorrectPinMessageVisible: false,
  isIncorrectPasswordMessageVisible: false,
  isIncorrectEmailMessageVisible: false,
  isConnectionFailedMessageVisible: false,
  isLoginModalOpen: false,
  isSignUpModalOpen: false,
  isManagingProfiles: false,
  isResetPasswordAccountNotFoundMessageVisible: false,
  isResetPasswordMatchMessageVisible: false,
  isProfileEditorModalOpen: false,
  isProfileEditorErrorMessageVisible: false,
  isProfileSelectorModalOpen: false,
  isUnauthorizedMessageVisible: false,
  profile: null,
  token: null,
  oldToken: null
};

function isUnauthorizedResult(action) {
  return Object.getOwnPropertyNames(api.events).reduce(
    (found, propertyName) => {
      const eventObject = api.events[propertyName];
      return (
        ('actionFail' in eventObject &&
          eventObject.actionFail === action.type &&
          action.error.status === 401) ||
        found
      );
    },
    false
  );
}

export default function auth(state = defaultState, action) {
  if (isUnauthorizedResult(action)) {
    return {
      ...state,
      editingProfile: null,
      hasProfile: false,
      hasToken: false,
      isFetching: false,
      isManagingProfiles: false,
      isProfileEditorModalOpen: false,
      isProfileSelectorModalOpen: false,
      isUnauthorizedMessageVisible: true,
      profile: null,
      token: null,
      oldToken: null
    };
  }

  switch (action.type) {
    case SIGN_UP_OPEN_MODAL:
      return {
        ...state,
        isSignUpModalOpen: true,
        isConnectionFailedMessageVisible: false
      };
    case SIGN_UP_CLOSE_MODAL:
      return {
        ...state,
        isSignUpModalOpen: false
      };
    case REQUEST_SENT_OPEN_MODAL:
      return {
        ...state,
        isRequestSentModalOpen: true,
      };
      case REQUEST_SENT_CLOSE_MODAL: {
        return {
          ...state,
          isRequestSentModalOpen: false,
        };
      }
    case LOGIN_OPEN_MODAL:
      return {
        ...state,
        isLoginModalOpen: true,
        isIncorrectPasswordMessageVisible: false,
        isUnauthorizedMessageVisible: false,
        isConnectionFailedMessageVisible: false
      };
    case LOGIN_CLOSE_MODAL:
      return {
        ...state,
        isLoginModalOpen: false
      };
    case LOGIN_RESET:
      return {
        ...state,
        isIncorrectPasswordMessageVisible: false,
        isUnauthorizedMessageVisible: false,
        isConnectionFailedMessageVisible: false
      };
    case LOGIN_REQUEST:
      return {
        ...state,
        isFetching: true,
        isIncorrectPasswordMessageVisible: false
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        hasToken: true,
        isFetching: false,
        isIncorrectPasswordMessageVisible: false,
        isUnauthorizedMessageVisible: false,
        isConnectionFailedMessageVisible: false,
        token: action.token,
        oldToken: null
      };
    case INVITES_REDEEM_SUCCESS:
      return {
        ...state,
        isFetching: false,
        token: action.data.token,
        hasToken: true,
        showIncorrectPasswordMessage: false,
        showUnauthorizedMessage: false
      };
    case LOGIN_FAILURE:
      if (action.err === 'TypeError') {
        return {
          ...state,
          isFetching: false,
          isConnectionFailedMessageVisible: true,
          isIncorrectPasswordMessageVisible: false,
          isUnauthorizedMessageVisible: false
        };
      }
      return {
        ...state,
        isFetching: false,
        isIncorrectPasswordMessageVisible: true,
        isConnectionFailedMessageVisible: false,
        isUnauthorizedMessageVisible: false
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        hasToken: false,
        hasProfile: false,
        isFetching: false,
        profile: null,
        token: null,
        oldToken: null
      };
    case FORGOT_PASSWORD_OPEN_MODAL:
      return {
        ...state,
        isForgotPasswordModalOpen: true,
        isForgotPasswordSuccessMessageVisible: false,
        isIncorrectEmailMessageVisible: false
      };
    case FORGOT_PASSWORD_CLOSE_MODAL: {
      if (state.isForgotPasswordSuccessMessageVisible) {
        return {
          ...state,
          isLoginModalOpen: false, // also close login modal
          isForgotPasswordModalOpen: false,
          isForgotPasswordSuccessMessageVisible: false
        };
      }
      return {
        ...state,
        isForgotPasswordModalOpen: false
      };
    }
    case FORGOT_PASSWORD_RESET:
      return {
        ...state,
        isForgotPasswordSuccessMessageVisible: false,
        isIncorrectEmailMessageVisible: false
      };
    case FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        isFetching: true,
        isForgotPasswordSuccessMessageVisible: false,
        isIncorrectEmailMessageVisible: false
      };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isForgotPasswordSuccessMessageVisible: true,
        isIncorrectEmailMessageVisible: false
      };
    case FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        isFetching: false,
        isForgotPasswordSuccessMessageVisible: false,
        isIncorrectEmailMessageVisible: true
      };
    case RESET_PASSWORD_RESET:
      return {
        ...state,
        isResetPasswordAccountNotFoundMessageVisible: false,
        isResetPasswordMatchMessageVisible: false,
        isResetPasswordSuccessMessageVisible: false
      };
    case RESET_PASSWORD_REQUEST:
      return {
        ...state,
        isFetching: true,
        isResetPasswordAccountNotFoundMessageVisible: false,
        isResetPasswordMatchMessageVisible: false,
        isResetPasswordSuccessMessageVisible: false
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isResetPasswordAccountNotFoundMessageVisible: false,
        isResetPasswordMatchMessageVisible: false,
        isResetPasswordSuccessMessageVisible: true
      };
    case RESET_PASSWORD_NOT_FOUND_FAILURE:
      return {
        ...state,
        isFetching: false,
        isResetPasswordAccountNotFoundMessageVisible: true,
        isResetPasswordMatchMessageVisible: false,
        isResetPasswordSuccessMessageVisible: false
      };
    case RESET_PASSWORD_MATCH_FAILURE:
      return {
        ...state,
        isFetching: false,
        isResetPasswordAccountNotFoundMessageVisible: false,
        isResetPasswordMatchMessageVisible: true,
        isResetPasswordSuccessMessageVisible: false
      };
    case SET_PROFILE:
      return {
        ...state,
        isLoginModalOpen: false,
        isProfileSelectorModalOpen: false,
        profile: action.profile,
        hasProfile: true
      };
    case PROFILE_EDITOR_OPEN_MODAL:
      return {
        ...state,
        isProfileEditorModalOpen: true,
        isProfileEditorErrorMessageVisible: false,
        editingProfile: action.profileId
      };
    case PROFILE_EDITOR_CLOSE_MODAL:
      return {
        ...state,
        isProfileEditorModalOpen: false,
        editingProfile: null
      };
    case PROFILE_SELECTOR_OPEN_MODAL:
      return {
        ...state,
        isManagingProfiles: false,
        isProfileSelectorModalOpen: true
      };
    case PROFILE_SELECTOR_CLOSE_MODAL:
      return {
        ...state,
        isManagingProfiles: false,
        isProfileSelectorModalOpen: false
      };
    case PROFILE_ENTER_MANAGE_MODE:
      return {
        ...state,
        isManagingProfiles: true
      };
    case PROFILE_LEAVE_MANAGE_MODE:
      return {
        ...state,
        isManagingProfiles: false
      };
    case PROFILE_PATCH_REQUEST:
    case PROFILE_PATCH_SUCCESS:
      return {
        ...state,
        isProfileEditorErrorMessageVisible: false
      };
    case PROFILE_PATCH_FAILURE:
      return {
        ...state,
        isProfileEditorErrorMessageVisible: true
      };
    case PROFILE_POST_REQUEST:
      return {
        ...state,
        isProfileEditorErrorMessageVisible: false
      };
    case PROFILE_POST_SUCCESS:
      return state.hasProfile
        ? {
            ...state,
            isProfileEditorErrorMessageVisible: false
          }
        : {
            ...state,
            isProfileEditorErrorMessageVisible: false,
            profile: action.data.id,
            hasProfile: true
          };
    case PROFILE_POST_FAILURE:
      return {
        ...state,
        isProfileEditorErrorMessageVisible: true
      };
    case UNLOCK_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case UNLOCK_SUCCESS:
      return {
        ...state,
        hasToken: true,
        isFetching: false,
        isIncorrectPinMessageVisible: false,
        token: action.data.token,
        oldToken: state.token
      };
    case UNLOCK_FAILURE:
      return {
        ...state,
        isFetching: false,
        isIncorrectPinMessageVisible: true
      };
    case LOCK_DIARY:
      return {
        ...state,
        token: state.oldToken,
        oldToken: null
      };
    case SET_UNAUTHORIZED_MESSAGE_VISIBLE:
      return {
        ...state,
        isUnauthorizedMessageVisible: true
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js